import { Box, HStack, Text } from "@chakra-ui/react";
import { FormInput, FormSelect, FormSwitch, FormTextarea, RemoveIconButton } from "../../ui/inputs";
import { createEmptyAiLevelPoints, AI_MATCH_LEVEL } from "../../models/scoringModel";
import { pointsColor } from "../../helpers/pointsColor";

const AiMatchRulesEditor = ({ config, onChange, labels, disabled = false }) => {
    const list = config.aiLevels ?? [];
    const update = (i, patch) => onChange({ aiLevels: list.map((l, idx) => (idx === i ? { ...l, ...patch } : l)) });
    const remove = (i) => onChange({ aiLevels: list.filter((_, idx) => idx !== i) });
    const add = () => onChange({ aiLevels: [...list, createEmptyAiLevelPoints()] });

    const levelOptions = Object.values(AI_MATCH_LEVEL)
        .filter((v) => v !== AI_MATCH_LEVEL.UNKNOWN)
        .map((v) => ({ value: v, label: labels.aiLevelOptions[v] }));

    return (
        <Box display="flex" flexDirection="column" gap={3}>
            <Box>
                <Text fontSize="xs" color="gray.500" fontWeight={600} textTransform="uppercase" letterSpacing="wider" mb={1}>
                    {labels.aiCriterion}
                </Text>
                <FormTextarea
                    value={config.aiCriterion ?? ""}
                    onChange={(e) => onChange({ aiCriterion: e.target.value })}
                    placeholder={labels.aiCriterionPlaceholder}
                    disabled={disabled}
                    rows={2}
                />
            </Box>

            <Text fontSize="xs" color="gray.500" fontWeight={600} textTransform="uppercase" letterSpacing="wider">
                {labels.aiLevelsTitle}
            </Text>
            {list.map((level, i) => (
                <HStack key={i} gap={3} align="center">
                    <Box flex={2}>
                        <FormSelect
                            value={level.level}
                            onChange={(v) => update(i, { level: v })}
                            options={levelOptions}
                            disabled={disabled}
                        />
                    </Box>
                    <Box flex={1}>
                        <FormInput
                            type="number"
                            placeholder={labels.pointsColumn}
                            disabled={disabled}
                            value={level.points ?? ""}
                            color={pointsColor(level.points, config.maxScore)}
                            onChange={(e) => update(i, { points: e.target.value === "" ? null : Number(e.target.value) })}
                        />
                    </Box>
                    <FormSwitch
                        label={labels.disqualifyColumn}
                        checked={!!level.disqualify}
                        onChange={(v) => update(i, { disqualify: v })}
                        disabled={disabled}
                        size="sm"
                    />
                    <RemoveIconButton onClick={() => remove(i)} disabled={disabled} />
                </HStack>
            ))}
            <Box
                as="button"
                type="button"
                onClick={add}
                disabled={disabled}
                alignSelf="flex-start"
                px={3}
                py={1.5}
                borderRadius={6}
                border="1px dashed"
                borderColor="gray.300"
                fontSize="xs"
                color="gray.500"
                opacity={disabled ? 0.5 : 1}
                cursor={disabled ? "not-allowed" : "pointer"}
                _hover={disabled ? undefined : { borderColor: "purple.400", color: "purple.600" }}
            >
                {labels.addAiLevel}
            </Box>
        </Box>
    );
};

export default AiMatchRulesEditor;
